
/* eslint-disable */
if (typeof Object.assign !== 'function') {
  Object.assign = function (target, varArgs) {
    'use strict'
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object')
    }

    var to = Object(target)

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index]

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey]
          }
        }
      }
    }
    return to
  }
}

export function camelCase (name) {
  return name.replace(/([\:\-\_]+(.))/g, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter
  })
}

export function isUndefined (value) {
  return typeof value === 'undefined'
}

export function isDefined (value) {
  return typeof value !== 'undefined'
}

export function isObject (value) {
  return value !== null && typeof value === 'object'
}

export function isBlankObject (value) {
  return value !== null && typeof value === 'object' && !getPrototypeOf(value)
}

export function isArray (value) {
  return Array.isArray(value)
}

function isArrayLike (obj) {
  if (obj == null || isWindow(obj)) return false
  if (isArray(obj) || isString(obj)) return true
  var length = 'length' in Object(obj) && obj.length
  return isNumber(length) &&
    (( length >= 0 ) && (((length - 1) in obj || obj instanceof Array)) || (typeof obj.item === 'function'))
}

export function isString (value) {
  return typeof value === 'string'
}

export function isNumber (value) {
  return typeof value === 'number'
}

export function isFunction (value) {
  return typeof value === 'function'
}

export function isPromise (value) {
  return value && isFunction(value.then)
}

export function isWindow (value) {
  return value && value.window === value
}

export function getPrototypeOf (value) {
  return Object.getPrototypeOf(value)
}

export function objectExtend (a, b) {
  // Don't touch 'null' or 'undefined' objects.
  if (a == null || b == null) {
    return a
  }

  Object.keys(b).forEach(function (key) {
    if (Object.prototype.toString.call(b[key]) === '[object Object]') {
      if (Object.prototype.toString.call(a[key]) !== '[object Object]') {
        a[key] = b[key]
      } else {
        a[key] = objectExtend(a[key], b[key])
      }
    } else {
      a[key] = b[key]
    }
  })

  return a
};

export function forEach (obj, iterator, context) {
  var key, length
  if (obj) {
    if (isFunction(obj)) {
      for (key in obj) {
        if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj)
        }
      }
    } else if (isArray(obj) || isArrayLike(obj)) {
      var isPrimitive = typeof obj !== 'object'
      for (key = 0, length = obj.length; key < length; key++) {
        if (isPrimitive || key in obj) {
          iterator.call(context, obj[key], key, obj)
        }
      }
    } else if (obj.forEach && obj.forEach !== forEach) {
      obj.forEach(iterator, context, obj)
    } else if (isBlankObject(obj)) {
      // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
      for (key in obj) {
        iterator.call(context, obj[key], key, obj)
      }
    } else if (typeof obj.hasOwnProperty === 'function') {
      // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
      for (key in obj) {
        if (obj.hasOwnProperty(key)) {
          iterator.call(context, obj[key], key, obj)
        }
      }
    } else {
      // Slow path for objects which do not have a method `hasOwnProperty`
      for (key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          iterator.call(context, obj[key], key, obj)
        }
      }
    }
  }
  return obj
}

/**
 * Assemble url from two segments
 *
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {String} baseUrl Base url
 * @param  {String} url     URI
 * @return {String}
 */
export function joinUrl (baseUrl, url) {
  if (/^(?:[a-z]+:)?\/\//i.test(url)) {
    return url
  }
  let joined = [baseUrl, url].join('/')
  let normalize = function (str) {
    return str
      .replace(/[\/]+/g, '/')
      .replace(/\/\?/g, '?')
      .replace(/\/\#/g, '#')
      .replace(/\:\//g, '://')
  }
  return normalize(joined)
}

/**
 * Get full path based on current location
 *
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {Location} location
 * @return {String}
 */
export function getFullUrlPath (location) {
  const isHttps = location.protocol === 'https:'
  return location.protocol + '//' + location.hostname +
    ':' + (location.port || (isHttps ? '443' : '80')) +
    (/^\//.test(location.pathname) ? location.pathname : '/' + location.pathname)
}

/**
 * Parse query string variables
 *
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {String} Query string
 * @return {String}
 */
export function parseQueryString (str) {
  let obj = {}
  let key
  let value;
  (str || '').split('&').forEach((keyValue) => {
    if (keyValue) {
      value = keyValue.split('=')
      key = decodeURIComponent(value[0])
      obj[key] = (value[1]) ? decodeURIComponent(value[1]) : true
    }
  })
  return obj
}

/**
 * Decode base64 string
 * @author Sahat Yalkabov <https://github.com/sahat>
 * @copyright Method taken from https://github.com/sahat/satellizer
 *
 * @param  {String} str base64 encoded string
 * @return {Object}
 */
export function decodeBase64 (str) {
  let buffer
  if (typeof module !== 'undefined' && module.exports) {
    try {
      buffer = require('safe-buffer').Buffer
    } catch (err) {
      // noop
    }
  }

  let fromCharCode = String.fromCharCode

  let re_btou = new RegExp([
    '[\xC0-\xDF][\x80-\xBF]',
    '[\xE0-\xEF][\x80-\xBF]{2}',
    '[\xF0-\xF7][\x80-\xBF]{3}'
  ].join('|'), 'g')

  let cb_btou = function (cccc) {
    switch (cccc.length) {
      case 4:
        let cp = ((0x07 & cccc.charCodeAt(0)) << 18) |
          ((0x3f & cccc.charCodeAt(1)) << 12) |
          ((0x3f & cccc.charCodeAt(2)) << 6) |
          (0x3f & cccc.charCodeAt(3))
        let offset = cp - 0x10000
        return (fromCharCode((offset >>> 10) + 0xD800) +
        fromCharCode((offset & 0x3FF) + 0xDC00))
      case 3:
        return fromCharCode(
          ((0x0f & cccc.charCodeAt(0)) << 12) |
          ((0x3f & cccc.charCodeAt(1)) << 6) |
          (0x3f & cccc.charCodeAt(2))
        )
      default:
        return fromCharCode(
          ((0x1f & cccc.charCodeAt(0)) << 6) |
          (0x3f & cccc.charCodeAt(1))
        )
    }
  }

  let btou = function (b) {
    return b.replace(re_btou, cb_btou)
  }

  let _decode = buffer ? function (a) {
    return (a.constructor === buffer.constructor
      ? a : Buffer.from(a, 'base64')).toString()
  } : function (a) {
    return btou(atob(a))
  }

  return _decode(
    String(str).replace(/[-_]/g, function (m0) {
      return m0 === '-' ? '+' : '/'
    }).replace(/[^A-Za-z0-9\+\/]/g, ''))
}



// WEBPACK FOOTER //
// ./src/_fdp/core/directive/acl/utils.js